import path from 'path';
import fs from 'fs-extra';
import chalk from 'chalk';

export async function validateProject() {
  const cwd = process.cwd();
  const packageJsonPath = path.join(cwd, 'package.json');
  
  if (!await fs.pathExists(packageJsonPath)) {
    throw new Error('No package.json found. Please run this command in a Node.js project directory.');
  }
  
  const packageJson = await fs.readJson(packageJsonPath);
  
  // Check if it's a React project
  const hasReact = 
    packageJson.dependencies?.react || 
    packageJson.devDependencies?.react ||
    packageJson.peerDependencies?.react;
    
  if (!hasReact) {
    console.log(chalk.yellow('⚠️  React not detected in dependencies. Make sure this is a React project.'));
  }
  
  // Check for TypeScript
  const hasTypeScript = 
    packageJson.dependencies?.typescript || 
    packageJson.devDependencies?.typescript ||
    await fs.pathExists(path.join(cwd, 'tsconfig.json'));
    
  if (!hasTypeScript) {
    console.log(chalk.yellow('⚠️  TypeScript not detected. FeedInbox components are written in TypeScript.'));
  }
  
  console.log(chalk.green('✅ Project validation passed'));
}